// ============================================================
// ADMIN LOGIN PAGE
// ============================================================

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User, Lock, Eye, EyeOff, AlertCircle, LogIn } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const LoginPage = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin/dashboard';

  if (isAuthenticated) {
    navigate(from, { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) {
      setError('Please enter both username and password');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await login(form.username, form.password);
      toast.success('Welcome back! Logged in successfully.', { icon: '🍛' });
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Invalid credentials');
      toast.error('Login failed. Please check credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-login-page">
        <div className="admin-login-bg-pattern" />
        <div className="admin-login-card">
          {/* Logo */}
          <div className="admin-login-logo">
            <div className="admin-login-logo-icon">🍛</div>
            <h1>Biryani Admin</h1>
            <p>Sign in to your admin panel</p>
          </div>

          {/* Error */}
          {error && (
            <div className="admin-login-error" style={{ marginBottom: 20 }}>
              <AlertCircle size={16} /> {error}
            </div>
          )}

          {/* Form */}
          <form className="admin-login-form" onSubmit={handleSubmit}>
            <div className="admin-login-input-group">
              <label>Username</label>
              <div className="admin-login-input-wrap">
                <User size={16} className="admin-login-input-icon" />
                <input
                  type="text"
                  placeholder="Enter username"
                  value={form.username}
                  onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
                  autoComplete="username"
                  autoFocus
                />
              </div>
            </div>

            <div className="admin-login-input-group">
              <label>Password</label>
              <div className="admin-login-input-wrap">
                <Lock size={16} className="admin-login-input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={form.password}
                  onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="admin-login-input-eye"
                  onClick={() => setShowPassword(p => !p)}
                >
                  {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" className="admin-login-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="admin-spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
                  Signing in...
                </>
              ) : (
                <>
                  <LogIn size={18} /> Sign In
                </>
              )}
            </button>
          </form>


        </div>
      </div>
    </div>
  );
};

export default LoginPage;
